const SurveyIframe = () => {
  return (
    <>
      <iframe
        title="backpain.today.survey"
        src="https://backpain.today/survey-iframe?partner=SAA"
        style={{
          width: "100%",
          height: "calc(100vh - 15px)",
          border: 0,
          display: "block",
        }}
      ></iframe>
    </>
  );
};

export default SurveyIframe;
